module.exports = __webpack_public_path__ + "media/images/arrow-left-small-659b430eba8ecf9ca58990eff12cb49b.svg";